// import React, { createContext, useState } from "react";

// const AuthContext = createContext({
//   newReq: {
//     view: null,
//     show: false,
//   },
//   setNewReq: () => {},
// });

// export const AuthProvider = ({ children }) => {
//   const [newReq, setNewReq] = useState({
//     view: null,
//     show: false,
//   });

//   return (
//     <AuthContext.Provider value={{ newReq, setNewReq}}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthContext;
import React, { createContext, useState } from "react";

const AuthContext = createContext({
  newReq: { view: null, show: false },
  setNewReq: () => {},
  newBond: { view: null, show: false },
  setNewBond: () => {},
});

export const AuthProvider = ({ children }) => {
  const [newReq, setNewReq] = useState({ view: null, show: false });
  const [newBond, setNewBond] = useState({ view: null, show: false });

  return (
    <AuthContext.Provider value={{ newReq, setNewReq, newBond, setNewBond }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
